/*export const PLAN_SETTINGS = {
  BUSINESS_STARTER_ID: 'prod_RYRCN77CHkkkia',
  BUSINESS_ESSENTIALS_ID: 'prod_RYRCcsV8DVKCqi',
  BUSINESS_GROWTH_ID: 'prod_RYRCkepP2K8ilf', //'prod_RTCeHLMNuQlsUQ',
  PREMIUM_ID: 'prod_OyaXSNJ9zJyeyD',
  BUSINESS_STARTER_ANNUAL_ID: 'prod_TqOvTVYYzyJdo9',
  BUSINESS_ESSENTIALS_ANNUAL_ID: 'prod_TqP9KBXHZYDtud',
  BUSINESS_GROWTH_ANNUAL_ID: 'prod_TqPD9XNmKmmmji',
};*/

export const PLAN_SETTINGS = {
  BUSINESS_STARTER_ID: 'prod_RYRCN77CHkkkia',
  BUSINESS_ESSENTIALS_ID: 'prod_TxB9fZ3U5I4RAu',
  BUSINESS_GROWTH_ID: 'prod_TxB8xczGnnVgm6', //'prod_RTCeHLMNuQlsUQ',
  PREMIUM_ID: 'prod_OyaXSNJ9zJyeyD',
  BUSINESS_STARTER_ANNUAL_ID: 'prod_TqOvTVYYzyJdo9',
  BUSINESS_ESSENTIALS_ANNUAL_ID: 'prod_TxB7dHAg3QNIa1',
  BUSINESS_GROWTH_ANNUAL_ID: 'prod_TxB6DrQX7WY8sa',
};
